<template>
  <div
    class="business-banner row items-center justify-between bg-grey-3"
  >
    <img
      class="business-banner-logo"
      :src="logo.src"
      @load="$emit('loadAllContent', true)"
      :style="
        logo.travelAgentBannerStyle
          ? logo.travelAgentBannerStyle
          : { maxWidth: 'calc(50% - 16px)' }
      "
    />

    <div class="col-6 row items-stretch justify-end q-ml-auto">
      <div
        :class="[
          'column items-end justify-center text-uppercase names',
          {
            'cursor-pointer': businessBanner.clickable,
            'cursor-default': !businessBanner.clickable,
          },
        ]"
        @click="openBusinessCard"
      >
        <div class="name text-weight-semibold text-right">{{ name }}</div>
        <div class="title text-right text-weight-semibold color-grey-5">
          {{ title }}
        </div>
      </div>

      <div
        :class="[
          'row items-center justify-center',
          {
            'cursor-pointer': businessBanner.clickable,
            'cursor-default': !businessBanner.clickable,
          },
        ]"
        @click="openBusinessCard"
      >
        <q-avatar class="avatar-image" v-if="avatar.src" size="40px">
          <img :src="avatar.src" />
        </q-avatar>
        <div
          class="row items-center justify-center avatar-name bg-white"
          v-else
        >
          {{ avatar.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DCardBusinessBanner",
  props: {
    businessBanner: {
      type: Object,
      required: true,
    },
  },
  computed: {
    logo: {
      get() {
        return this.businessBanner.logo ?? {};
      },
    },
    name: {
      get() {
        return this.businessBanner.name;
      },
    },
    title: {
      get() {
        return this.businessBanner.title;
      },
    },
    avatar: {
      get() {
        return this.businessBanner.avatar;
      },
    },
  },
  methods: {
    openBusinessCard() {
      if (!this.businessBanner.clickable) {
        return;
      }

      this.$emit("openBusinessCard");
    },
  },
};
</script>

<style lang="scss" scoped>
.business-banner {
  margin-left: -12px;
  margin-right: -12px;
  max-height: 64px;
  padding: 12px 16px;

  &-logo {
    max-height: 40px;
  }
}

.names {
  width: calc(100% - 50px);
  .name {
    color: #333333;
    font-size: 12px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  .title {
    font-size: 8px;
    line-height: 11px;
  }
}

.avatar {
  &-name {
    width: 40px;
    height: 40px;
    border-radius: 100%;
    font-size: 16px;
    padding-bottom: 2px;
    color: #373737;
  }

  &-name,
  &-image {
    margin-left: 10px;
  }
}

.cursor-default {
  cursor: default;
}
</style>
